export const menu = {
  home: "首页",
  corporateIdentity: "企业形象",
  pages: "页面",
  aboutUs: "关于我们",
  faq: "常见问题",
  error404: "错误 404",
  services: "服务",
  maritimeLaw: "海事法",
  taxLaw: "税法",
  customsLaw: "海关法",
  commercialLaw: "商业法",
  insurance: "保险",
  administrativeProcesses: "行政程序",
  stsOperations: "STS船对船操作",
  contact: "联系",
  language: "语言",
  spanish: "西班牙语",
  english: "英语",
  chinese: "中文",
  contactUs: "联系我们",
  ofac: "OFAC"
};
